import { Component } from "react";

import { lazyLoadWithRetry } from "utilities/react.utilities";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { BTButtonDeprecated } from "commonComponents/btWrappers/BTButtonDeprecated/BTButtonDeprecated";
import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { withErrorBoundary } from "commonComponents/helpers/ErrorBoundary/ErrorBoundary";

import { AccountingSettingsHandler } from "entity/accounting/AccountingSettings/AccountingSettings.api.handler";

import { type IBannerAlertProps } from "../HeaderAlerter.types";

const AccountingSettings = lazyLoadWithRetry(
    () => import("entity/accounting/AccountingSettings/AccountingSettings"),
);

interface IAccountingBannerState {
    headerAlertModal: boolean;
}

class AccountingBannerInternal extends Component<IBannerAlertProps, IAccountingBannerState> {
    state: IAccountingBannerState = {
        headerAlertModal: false,
    };

    render() {
        const alert = this.props.alert;

        const alertMessage = (
            <>
                {`${alert.alertText} `}
                <BTButtonDeprecated
                    data-testid="headerAlert"
                    onClick={this.toggleHeaderAlertModal}
                    type="link"
                    isolated
                >
                    {`${alert.redirectText} `}
                </BTButtonDeprecated>
            </>
        );

        return (
            <>
                <BTAlert
                    title={alert.alertTitle}
                    message={alertMessage}
                    type="warning"
                    data-testid="accountingWarning"
                    showIcon
                />
                {this.renderHeaderAlertModal()}
            </>
        );
    }

    private renderHeaderAlertModal = () => {
        return (
            <>
                {this.state.headerAlertModal && (
                    <BTSuspense>
                        <AccountingSettings
                            {...this.props}
                            isReconnecting={true}
                            modalConfig={{
                                parentRoute: this.props.match.url,
                                beforeClose: this.toggleHeaderAlertModal,
                            }}
                            history={this.props.history}
                            location={this.props.location}
                            handler={new AccountingSettingsHandler()}
                        />
                    </BTSuspense>
                )}
            </>
        );
    };

    private toggleHeaderAlertModal = () => {
        this.setState({
            headerAlertModal: !this.state.headerAlertModal,
        });
    };
}

const AccountingBanner = withErrorBoundary(AccountingBannerInternal)(
    "Could not load Accounting Banner",
);

export default AccountingBanner;
